import { fetchAPI } from '@quickbit/backoffice-core-frontend';

type MerchantStatus = 'ACTIVE' | 'BLOCKED';

export interface PlatformMerchant {
  merchantId: string;
  name: string;
  status: MerchantStatus;
}

export interface Organisation {
  uuid: string;
  name: string;
  isPlatform: boolean;
  merchants: PlatformMerchant[];
  needsKyb: boolean;
}

export const getOrganisation = async () => {
  return fetchAPI<Organisation>(`v1/organisation`);
};
